import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Input } from "reactstrap";
import fetchStoreListForProductListingService from "../../../../../Service/OPSServices/AmazonProductListing/fetchStoreListForProductListingService";
import { connect } from 'react-redux';

function ProductListingStore(props) {

  const [selectedStore, setSelectedStore] = useState("");
  const [storeList, setStoreList] = useState([])
  const [selectedStoreDetails, setSelectedStoreDetails] = useState(null);
  useEffect(() => {
    fetchStoreListForProductListingService(props.token).then((res) => {
      if (res) {
        console.log(res);
        setStoreList(res.storeList)
      }
    });
  }, []);

  const handleStoreChange = (e) => {
    const storeId = e.target.value
    setSelectedStore(storeId)

    const store = storeList.find(s => s.id == storeId)
    setSelectedStoreDetails(store)
  }
  
  return (

    <Container>

      <Row>

        {/* Page Title */}

        <Col md={12} className="mt-4 mb-3">
          <h4>Step 1 : Store Selection</h4>
        </Col>


        {/* Store Selection Card */}

        <Col md={12} className="ml-4 mr-4">

          <Card className="p-4">

            <Row className="mb-3">

              <Col md={4} className="amazon-listing-labels">Store : </Col>

              <Col md={8}>

                <Input
                  type="select"
                  value={selectedStore}
                  onChange={handleStoreChange}
                >

                  <option value="">-- Select Store --</option>

                  {storeList && storeList.map((store) => (
                    <option key={store.id} value={store.id}>
                      {store.name}
                    </option>
                  ))}

                </Input>

              </Col>

            </Row>


            {/* Store Details */}

            {selectedStoreDetails && (

              <Row className="mt-4">

                <Col md={6}>
                  <p className="mb-0"><b>Seller ID</b></p>
                  <p>{selectedStoreDetails.stringID}</p>
                </Col>

                <Col md={6}>
                  <p className="mb-0"><b>Marketplace ID</b></p>
                  <p>{selectedStoreDetails.marketplaceStringId}</p>
                </Col>

                <Col md={6}>
                  <p className="mb-0"><b>Currency</b></p>
                  <p>{selectedStoreDetails.currencyCode}</p>
                </Col>

              </Row>

            )}

          </Card>

        </Col>


        {/* Next Button */}

        <Col md={12} className="mt-3 d-flex justify-content-end">

          <button
            className="btn btn-primary"
            disabled={!selectedStore}
            onClick={() =>
              props.nextStep({
                storeId: selectedStoreDetails.id,
                sellerId: selectedStoreDetails.stringID,
                marketplaceId: selectedStoreDetails.marketplaceStringId,
                currency: selectedStoreDetails.currencyCode
              })
            }
          >
            Next →
          </button>

        </Col>

      </Row>

    </Container>

  );
}
const mapStateToProps = state => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
  }
}

export default connect(mapStateToProps)(ProductListingStore);